export const decryptParams = async (encryptedPayload) => {
  console.info("🔍 encryptedPayload recebido:", encryptedPayload);

  if (!encryptedPayload || typeof encryptedPayload !== "string") {
    throw new Error("Payload inválido ou ausente");
  }

  let payloadString: string;
  try {
    payloadString = atob(encryptedPayload);
    console.info("📦 Payload decodificado:", payloadString);
  } catch (e) {
    console.error("❌ Erro ao decodificar base64:", e);
    throw new Error("Falha ao decodificar base64: payload inválido");
  }

  let payload;
  try {
    payload = JSON.parse(payloadString);
    console.info("✅ Payload JSON parseado:", payload);
  } catch (e) {
    console.error("❌ Erro ao fazer JSON.parse:", e, payloadString);
    throw new Error("Falha ao fazer JSON.parse do payload decodificado");
  }

  const { rules, url } = payload;
  const isCriptoPayload = rules && url;
  if (isCriptoPayload) {
    // Payload simples, retornado em fallback (ambiente 192.168.x.x)
    console.warn("⚠️ Payload simples detectado. Apenas decodificado.");
    return payload;
  }

  const { salt, iv, data, ref } = payload;

  if (!data || data.length === 0) {
    throw new Error("Dados criptografados ausentes no payload.");
  }

  const encodedRule = new Uint8Array(ref);

  const keyMaterial = await crypto?.subtle?.importKey(
    "raw",
    encodedRule,
    "PBKDF2",
    false,
    ["deriveKey"]
  );

  const cryptoKey = await crypto?.subtle?.deriveKey(
    {
      name: "PBKDF2",
      salt: new Uint8Array(salt),
      iterations: 1000,
      hash: "SHA-256",
    },
    keyMaterial,
    {
      name: "AES-GCM",
      length: 256,
    },
    true,
    ["decrypt"]
  );

  const decryptedData = await crypto?.subtle?.decrypt(
    {
      name: "AES-GCM",
      iv: new Uint8Array(iv),
    },
    cryptoKey,
    new Uint8Array(data)
  );

  return JSON.parse(new TextDecoder().decode(decryptedData));
};
